import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button } from '@beehive/components';
import SmProjectDetailDrawer, {
  ProjectDetailProps,
} from 'containers/SmWorkbench/ProjectDetail/Drawer';
import * as actions from 'modules/actions/outProjectDetail';
import { projectMove, projectDelete } from 'modules/actions/outProjectMove';
import { MENUS_REQUEST_ACTONS_MAPPING, getAttachementDownloadLink, QuotationsType } from '../../utils';
import { HALF_COL_PROPS } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/PlanInfo';

class ProjectDetailDrawer extends React.Component<ProjectDetailProps> {
  getBodyProgress = () => {
    return require('../Show/Progress/index').default;
  }

  getBottomTabElement = (activeTabKey: string) => {
    let tabElement: any = null;
    try {
      tabElement = require(`../Show/Detail/Bottom/${_.upperFirst(
        activeTabKey,
      )}/index`).default;
    } catch (err) {
      tabElement = null;
    }
    return tabElement;
  }

  handleBaseInfoFormItems(formItems: any, params: any) {
    const { detail } = params;
    const { source_id = '' } = detail || {};

    if (source_id) {
      formItems.push({
        key: 'source_id',
        label: 'source_id',
        render: (value: any) => {
          return (
            <Button
              link
              href={`#/smWorkbench/projectDetailSingle/${value}`}
              target="_blank"
            >
              {value}
            </Button>
          );
        },
      });
    }
  }

  public getAppendFormBasicItems(formItemFields: Array<Record<string, any>>, detail: any) {
    formItemFields.splice(1, 0, { key: 'category_names', label: 'categories', ...HALF_COL_PROPS });
    const { project_plan_info = {} } = detail;
    const isAds = project_plan_info.ad_settle_way;
    if (isAds) {
      formItemFields.push({
        key: 'ad_settle_way_name',
        label: 'ad_settle_way',
        align: 'left',
      });
    }
    formItemFields.forEach((item) => {
      if (item.key === 'translated_plan_type') {
        Object.keys(HALF_COL_PROPS).forEach((field: string) => {
          item[field] = HALF_COL_PROPS[field];
        });
      }
    });
    return formItemFields;
  }

  public getAppendTableColumns(tableColumns: Array<Record<string, any>>, detail: any) {
    const { project_plan_info = {} } = detail;
    const isAdsXiaohao = project_plan_info.ad_settle_way === QuotationsType.XIAOHAO;
    tableColumns.push({
      key: 'translated_currency',
      title: 'currency',
      align: 'right',
      width: 100,
    });
    if (isAdsXiaohao) {
      tableColumns = tableColumns
        .filter((v: any) => !['quote_price', 'translated_currency'].includes(v.key))
        .map((v: any) => ({
          ...v,
          width: undefined,
        }));
      tableColumns.push({
        key: 'program_desc',
        title: 'program_desc',
        align: 'left',
      });
    }
    return tableColumns;
  }

  render() {
    return (
      <SmProjectDetailDrawer
        {...this.props}
        menuRequestMapping={MENUS_REQUEST_ACTONS_MAPPING}
        getBodyProgress={this.getBodyProgress}
        getBottomTabElement={this.getBottomTabElement}
        baseInfoProps={{
          handleFormItems: this.handleBaseInfoFormItems,
        }}
        planInfoConfig={{
          getAppendFormBasicItems: this.getAppendFormBasicItems,
        }}
        settleInfoConfig={{
          getAppendTableColumns: this.getAppendTableColumns,
        }}
        getAttachementDownloadLink={getAttachementDownloadLink}
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  const account = state.account;
  const projectDetail = state.outProjectDetail;
  const menu = _.find(_.get(account, 'menus') || [], (menu: any) => {
    return menu.key === 'outWorkbench';
  });
  return {
    readOnly: false,
    menus: _.get(menu, 'children'),
    projectDetail,
  };
};

const mapDispatchToProps = () => {
  return {
    loadDetail: actions.loadDetail,
    clearDetail: actions.clearDetail,
    toggleDrawerSiderShow: actions.toggleDrawerSiderShow,
    projectMove,
    projectDelete,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailDrawer);
